"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getDidomiConfig", {
    enumerable: true,
    get: function() {
        return getDidomiConfig;
    }
});
var _object_spread = require("@swc/helpers/_/_object_spread");
var _noticecss = require("./notice-css");
var _translations = require("./translations");
var getFontFamilyFromCSS = function() {
    return getComputedStyle(document.querySelector("html")).fontFamily;
};
function getDidomiConfig() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var fontFamily = options.fontFamily, locale = options.locale, _options_privacyPolicyURL = options.privacyPolicyURL, privacyPolicyURL = _options_privacyPolicyURL === void 0 ? "" : _options_privacyPolicyURL;
    var defaultLocale = "en";
    var currentLocale = locale === "gl" ? "es" : locale || defaultLocale;
    var enabledLocales = [
        currentLocale,
        defaultLocale
    ];
    return _object_spread._({
        app: _object_spread._({}, privacyPolicyURL && {
            privacyPolicyURL: privacyPolicyURL
        }),
        languages: {
            enabled: Array.from(new Set(enabledLocales)),
            default: currentLocale
        },
        notice: {
            /*
       * enable :
       * Not displaying the notice in privacy policy page
       * https://support.didomi.io/not-to-display-the-notice-in-your-privacy-policy
       */ enable: typeof window !== "undefined" ? privacyPolicyURL !== window.location.href : true,
            content: {
                learnMore: _translations.LEARN_MORE_BUTTON,
                dismiss: _translations.AGREE_COOKIES_BUTTON
            }
        },
        user: {
            /*
       * Share the consents between web & mobile app
       */ externalConsent: {
                enabled: true
            },
            bots: {
                /**
         * Indicate whether consent is required for bots
         */ consentRequired: false,
                /**
         * Predefined types of bots to identify
         * Defaults to all types supported by the SDK
         * (Optional)
         */ types: [
                    "crawlers",
                    "performance"
                ],
                /**
         * List of additional regular expressions to match
         * against the User Agent of the visitor.
         * When one of the regular expressions matches, the user
         * is considered to be a bot.
         * This allows you to identify extra bots that the SDK does not
         * know about.
         * Regular expressions must be specified as strings and correctly
         * escaped.
         * (Optional)
         */ extraUserAgents: [
                    "Mozilla\\/5.0 \\(X11; Linux x86_64\\) AppleWebKit\\/537.36 \\(KHTML, like Gecko\\) HeadlessChrome\\/(.)* Safari\\/537.36 Prerender \\(\\+https:\\/\\/github.com\\/prerender\\/prerender\\)",
                    "Mozilla\\/5.0 \\(Linux; Android 11; Pixel 5\\) AppleWebKit\\/537.36 \\(KHTML, like Gecko\\) Chrome\\/(.)* Mobile Safari\\/537.36 Prerender \\(\\+https:\\/\\/github.com\\/prerender\\/prerender\\)",
                    "Mozilla\\/5.0 \\(Linux; Android 7.0; Moto G \\(4\\)\\) AppleWebKit\\/537.36 \\(KHTML, like Gecko\\) Chrome\\/(.)* Mobile Safari\\/537.36 Chrome-Lighthouse"
                ]
            }
        }
    }, (0, _noticecss.getStyles)(fontFamily || getFontFamilyFromCSS()));
}

//# sourceMappingURL=config.js.map